module.exports = __webpack_public_path__ + "static/media/progger1.6edca90d.png";